import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const DURATION_SECONDS = 48 * 60 * 60;
const pad = (value: number): string => String(value).padStart(2, '0');
export function UrgencyBar() {
  const [secondsLeft, setSecondsLeft] = useState(DURATION_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  return <div className="sticky top-0 z-50 w-full border-b border-flame-600/60 bg-flame-500" data-id="element-110" data-mp="2p6n4a098agzo">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-2 px-4 py-2.5 text-center sm:flex-row sm:gap-4" data-id="element-111" data-mp="2k7a7amon7tjd">
        <p className="flex items-center gap-2 text-[13px] font-semibold leading-snug text-white sm:text-sm" data-id="element-112" data-mp="2f6w5hmdmxfts">
          <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-113" data-mp="2b7x7klqbmjbu" />
          <span data-id="element-114" data-mp="1rwixlvrbrruh">
            <span className="font-extrabold uppercase" data-id="element-115" data-mp="1rvzpt7ve2ju6">¡Oferta de lanzamiento!</span> Método
            Híbrido 2.0 con 70% OFF y los 5 bonos premium incluidos.
          </span>
        </p>
        <p className="flex items-center gap-1 font-display text-lg font-bold tabular-nums text-white" aria-live="off" data-id="element-116" data-mp="1i0pnsk4zqcge">
          <span className="rounded bg-black/25 px-2 py-0.5" data-id="element-117" data-mp="2ao1ynx1sgvtv">{pad(hours)}</span>
          <span aria-hidden="true" data-id="element-118" data-mp="2alzazjo3zesb">:</span>
          <span className="rounded bg-black/25 px-2 py-0.5" data-id="element-119" data-mp="2fn56tqd2fi62">{pad(minutes)}</span>
          <span aria-hidden="true" data-id="element-120" data-mp="21ndtzsyac7tn">:</span>
          <span className="rounded bg-black/25 px-2 py-0.5" data-id="element-121" data-mp="21mklonjoha9e">{pad(seconds)}</span>
          <span className="sr-only" data-id="element-122" data-mp="25no1xb5n18b5">restantes de la oferta</span>
        </p>
      </div>
    </div>;
}